module.exports = __webpack_public_path__ + "assets/img/thumb-Ram-Group-Website.cab3124d.jpg";